import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import InstallPWAButton from "./InstallPWAButton.js";
import mainContext from "../context/mainContext";

export default function Header() {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const { handleCards, handleIsAuthed, isAuthed } = useContext(mainContext);

  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    handleIsAuthed(false);
    nav("/login");
  }

  const getInitialTheme = () => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) return savedTheme === "dark";
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  };

  const [darkMode, setDarkMode] = useState(getInitialTheme);

  useEffect(() => {
    document.body.className = darkMode ? "dark" : "light";
    localStorage.setItem("theme", darkMode ? "dark" : "light");
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.setAttribute("content", darkMode ? "#0b0d17" : "#f8f9fa");
    }
  }, [darkMode]);

  const isReviewPage = pathname.startsWith("/review");
  const isHomePage = pathname.startsWith("/home");

  const resetCards = () => {
    handleCards({
      one: [], two: [], three: [], four: [], five: [],
      six: [], seven: [], eight: [], nine: [],
    });
  };

  return (
    <header className="header">
      <div className="container">
        <div className="brand">
          <img className="logo" src="https://leitnerpwa.umlang.com/icons/logo48.png" alt="" />
          <span className="title">UMLANG LEITNER</span>
        </div>
        <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
          <button className="btn ghost small" onClick={() => setDarkMode(!darkMode)} aria-label="تغییر حالت تاریک/روشن">
            {darkMode ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 4.5a1 1 0 0 1 1 1V7a1 1 0 1 1-2 0V5.5a1 1 0 0 1 1-1Z" fill="currentColor"/>
                <path d="M5.64 5.64a1 1 0 0 1 1.42 0l.35.35a1 1 0 1 1-1.42 1.42l-.35-.35a1 1 0 0 1 0-1.42Z" fill="currentColor"/>
                <path d="M17.66 5.66a1 1 0 0 1 0 1.42l-.35.35a1 1 0 1 1-1.42-1.42l.35-.35a1 1 0 0 1 1.42 0Z" fill="currentColor"/>
                <path d="M4.5 12a1 1 0 0 1 1-1h1.5a1 1 0 1 1 0 2H5.5a1 1 0 0 1-1-1Z" fill="currentColor"/>
                <path d="M16.5 12a1 1 0 0 1 1-1h1.5a1 1 0 1 1 0 2h-1.5a1 1 0 0 1-1-1Z" fill="currentColor"/>
                <path d="M5.64 18.36a1 1 0 0 1 0-1.42l.35-.35a1 1 0 1 1 1.42 1.42l-.35.35a1 1 0 0 1-1.42 0Z" fill="currentColor"/>
                <path d="M17.66 18.34a1 1 0 0 1 0 1.42l-.35.35a1 1 0 1 1-1.42-1.42l.35-.35a1 1 0 0 1 1.42 0Z" fill="currentColor"/>
                <path d="M12 16.5a1 1 0 0 1 1-1h.5a1 1 0 1 1 0 2h-.5a1 1 0 0 1-1-1Z" fill="currentColor"/>
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3a9 9 0 0 0 0 18c.55 0 1-.45 1-1v-1.5a1 1 0 0 0-1-1 7 7 0 0 1 0-12 1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Z" fill="currentColor"/>
                <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" fill="currentColor"/>
              </svg>
            )}
          </button>
          {isAuthed && (
            <>
              {!isHomePage && (
                <Link className="btn ghost small" onClick={resetCards} to="/home" style={{ textDecoration: "none" }}>
                  خانه
                </Link>
              )}
              {!isReviewPage && (
                <button className="btn danger small" onClick={logout}>
                  خروج
                </button>
              )}
              <InstallPWAButton />
            </>
          )}
          {!isAuthed && pathname !== "/login" && (
            <button className="btn small" onClick={() => nav("/login")}>
              ورود
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
